var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row m-0" }, [
    _c(
      "div",
      { staticClass: "col-md-12 col-lg-12 col-sm-12 p-0" },
      [
        _vm.servicesList.length
          ? _c("div", { staticClass: "p-0 col-xs-12 first_table" }, [
              _c("table", { staticClass: "table activity-tracker-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.tableHeaders, function (header) {
                        return [
                          header !== "plan_id"
                            ? _c(
                                "th",
                                {
                                  key: header,
                                  class: { "w-35": header === "name" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("capitalize")(header)) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                      _c("th", { staticClass: "w-6" }),
                    ],
                    2
                  ),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.servicesList, function (service) {
                    return _c(
                      "tr",
                      {
                        key: service.id,
                        class: {
                          greyout: !service.active,
                        },
                      },
                      [
                        _vm._l(_vm.tableHeaders, function (header) {
                          return [
                            header !== "plan_id"
                              ? _c("td", { key: header }, [
                                  ["added_date", "expiry_date"].includes(header)
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFormatter")(
                                                service[header]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : header === "active"
                                    ? _c("div", [
                                        service[header]
                                          ? _c("img", {
                                              attrs: {
                                                src: "/static/images/icons/check.svg",
                                                alt: "check-icon",
                                              },
                                            })
                                          : _vm._e(),
                                      ])
                                    : header === "name" && !service.active
                                    ? _c("div", [
                                        _c("span", [
                                          _vm._v(_vm._s(service[header]) + " "),
                                          _c("img", {
                                            staticClass: "image-size",
                                            attrs: {
                                              src: "/static/images/icons/expiry-grey.svg",
                                              alt: "expiry-icon",
                                            },
                                          }),
                                        ]),
                                      ])
                                    : _c("div", [
                                        _vm._v(_vm._s(service[header])),
                                      ]),
                                ])
                              : _vm._e(),
                          ]
                        }),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "account_header_content cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.routeURL(
                                    "/layout/prodclassificationactivitytracker"
                                  )
                                },
                              },
                            },
                            [
                              service.plan_id === 7
                                ? _c("img", {
                                    attrs: {
                                      src: "/static/images/icons/chevron_right.svg",
                                      alt: "chevron-right-icon",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ])
          : _c("div", { staticClass: "norecords_wrapper p-20" }, [
              _c("div", { staticClass: "no-records-found" }, [
                _vm._v("No Records Found"),
              ]),
            ]),
        _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }